import * as e from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/SpeakerSlash.es.js";
const a = e.forwardRef((o, r) => /* @__PURE__ */ e.createElement(s, { ref: r, ...o, weights: t }));
a.displayName = "SpeakerSlashIcon";
const c = a;
export {
  c as SpeakerSlash,
  a as SpeakerSlashIcon
};
